import React from 'react';

import { logger, permissions, setRouter } from 'src/helpers';

const intervalIds = {};
export default class BaseComponent extends React.PureComponent {
  log = logger.component.bind(logger, 'component');
  warn = logger.warn.bind(logger, 'component');

  state = {};

  subscription = (model, cb) => {
    this.forceUpdate(cb);
    if (this.props.router) setRouter(this.props.router);
  };

  navigate = (url, params = {}) => {
    if (this.props.router) {
      permissions.history = {
        url,
        params: { ...params },
        oldUrl: this.props.router?.location.pathname
      };
      this.props.router.navigate(url, {
        ...params
      });
    } else {
      console.warn('navigate fail: no router passed', url);
    }
  };

  back = () => {
    this.navigate(-1);
  };

  addListenWidthWindow() {
    if (this.updateWidthWindow) {
      window.addEventListener('resize', this.updateWidthWindow);
    }
  }

  removeListenWidthWindow() {
    if (this.updateWidthWindow) {
      window.removeEventListener('resize', this.updateWidthWindow);
    }
  }

  timer = (enable, intervalId) => {
    const id = intervalIds[intervalId];
    if (id) this.clearTimer(intervalId);
    if (enable()) {
      intervalIds[intervalId] = setInterval(() => {
        this.setState({ renderId: (this.state.renderId || 1) + 1 });
        if (!enable()) this.clearTimer(intervalId);
        console.log(enable(), this.state.renderId);
      }, 1000);
    }
  };
  clearTimer = (intervalId) => {
    const id = intervalIds[intervalId];
    if (id) clearInterval(id);
    intervalIds[intervalId] = null;
  };
}
